import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const SchlaganfallVorsorgePage = () => {
  return (
    <Layout>
      <PageHero
        title="Schlaganfall-Vorsorge: Check der Halsschlagadern"
        subtitle="Wir untersuchen Ihre Halsschlagadern (Carotis-Duplex), um das Schlaganfallrisiko frühzeitig zu erkennen."
        backgroundImage="/images/Kardio 6.webp"
        ctaText="Schlaganfall-Vorsorge buchen"
      />

      <ContentSection
        title="Risiken minimieren, Leben schützen"
        content="Verengungen oder Ablagerungen in den Halsschlagadern (Carotis-Stenosen) sind eine Hauptursache für Schlaganfälle. Mit der Duplex-Sonographie der Halsschlagadern können wir diese gefährlichen Veränderungen frühzeitig erkennen und entsprechende präventive Maßnahmen einleiten, um Ihr Schlaganfallrisiko zu minimieren."
        image="/images/Kardio 6.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Schlaganfall-Prävention durch Carotis-Duplex in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet eine spezialisierte Vorsorgeuntersuchung der Halsschlagadern zur Minimierung des Schlaganfallrisikos."
      />

      <CTASection
        title="Schützen Sie sich vor einem Schlaganfall"
        subtitle="Vereinbaren Sie einen Termin für die Carotis-Duplex-Untersuchung zur Schlaganfall-Vorsorge."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default SchlaganfallVorsorgePage;
